import React from "react";
import Space from "./Space";

export default function Status(props) {

    const { type = "", style={} } = props;

    let _class = "ui-status active";
  

    return (
        <div {...style} className={_class}>{props.children}</div>
    )
}